import type { AxiosResponse } from "axios";

import type { S3PutSuccess } from "./base";
import { HeaderMap, baseService } from "./base";

type S3AuthData = {
  file: Blob | File;
  acl: string;
  "Content-Type"?: string;
  contentType?: string;
  "x-amz-meta-filename"?: string;
  filename?: string;
};

export const s3Service = {
  async auth(filename: string): Promise<unknown> {
    const response = await baseService.post("/api/user-content/auth", {
      filename,
    });
    return response.data;
  },

  async upload(
    presignedUrl: string,
    authData: S3AuthData,
  ): Promise<AxiosResponse | S3PutSuccess> {
    const { file, acl } = authData;

    const contentType = authData["Content-Type"] || authData.contentType;
    const metaFilename = authData["x-amz-meta-filename"] || authData.filename;

    const headers: HeaderMap = {
      "Content-Type": contentType || "application/octet-stream",
      "x-amz-acl": acl,
      "x-amz-meta-filename": metaFilename || "",
    };

    try {
      return await baseService.put(presignedUrl, file, "binary", headers, true);
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      console.error("S3 upload failed:", message);
      throw error;
    }
  },
};

export default s3Service;
